export const GET_USER = 'GET_USER'
export const USER_CODE_LOADING = 'USER_CODE_LOADING'
export const GET_USER_CODE = 'GET_USER_CODE'
export const USER_LOADING = 'USER_LOADING'
export const GET_TRANSACTIONS = 'GET_TRANSACTIONS';
export const ADD_TRANSACTION = 'ADD_TRANSACTION';
export const UPDATE_TRANSACTION_STATUS = 'UPDATE_TRANSACTION_STATUS';